import getComponent from '../utils/get-component'

export default getComponent(
  'silver flex-grow-0 pb4 pt3 flex items-center justify-center flex-wrap',
  'footer'
)
